import React from "react";
import moment from "moment";
import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
  Label,
  FormGroup,
} from "reactstrap";
import firebase from "../../../Firebase.js";
import { notification, message, Button, Input } from "antd";
import "antd/dist/antd.css";

class DirectNewCosturaRecord extends React.Component {
  constructor() {
    super();
    this.ref = firebase.firestore().collection("costura");
    this.state = {
      fechaIngreso: new Date(),
      estilo: null,
      isOpen: false,
      color: null,
      cantIngresada: "",
      label: null,
      op: null,
      ft: null,
      cantpcp: null,
      total: null,
      value: null,
      comercialId: null,
      comercialIndex: null,
      isActive: false,
      cantidadCorte: null,
    };
  }

  componentDidMount() {
    const { ordenPedido } = this.props.location.state;
    const { colorState } = this.props.location.state;
    const { cantidadCorte } = this.props.location.state;
    this.setState({ cantidadCorte: cantidadCorte });

    this.ref
      .where("op", "==", ordenPedido)
      .where("color", "==", colorState)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.setState({
            value: doc.data().index,
            color: colorState,
            op: ordenPedido,
          });
        });
      });

    firebase
      .firestore()
      .collection("comercial")
      .where("op", "==", ordenPedido)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.setState({
            comercialIndex: doc
              .data()
              .otros.map((v) => v.color)
              .indexOf(colorState),
            comercialId: doc.id,
          });
        });
      });
  }

  handleChangeIngreso = (date) => {
    this.setState({
      fechaIngreso: date,
    });
  };

  onChange = (e) => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  onSubmit = (e) => {
    e.preventDefault();

    let {
      fechaIngreso,
      cantIngresada,
      value,
      comercialId,
      comercialIndex,
      op,
      color,
      cantidadCorte,
    } = this.state;

    if (cantIngresada <= cantidadCorte) {
      this.setState({
        isActive: false,
      });
      message.loading("Registrando...", 60);
      fechaIngreso = moment(fechaIngreso).format("DD/MM/YYYY");

      this.ref
        .doc(value)
        .get()
        .then((res) => {
          const costura = res.data();
          costura.otros.push({
            fechaEntrada: fechaIngreso,
            cantEntrada: Number(cantIngresada),
            servicio: "TexCross",
          });
          costura.isEditable = true;
          costura.estado[0] = "En Curso";

          try {
            firebase
              .firestore()
              .collection("comercial")
              .doc(comercialId)
              .get()
              .then((doc) => {
                let otros = doc.data().otros;
                otros[comercialIndex] = {
                  ...otros[comercialIndex],
                  costura: {
                    fechaIngreso,
                    cantidadIngresada: cantIngresada,
                    servicio: "TexCross",
                  },
                };

                firebase
                  .firestore()
                  .collection("comercial")
                  .doc(comercialId)
                  .set({ otros }, { merge: true });
              });
          } catch (error) {
            console.error("Error adding document: ", error);
          }

          try {
            firebase
              .firestore()
              .collection("ing")
              .where("op", "==", costura.op)
              .get()
              .then((querySnapshot) => {
                querySnapshot.forEach((doc) => {
                  let otros = doc.data().otros;
                  otros.forEach((item) => {
                    if (item.color === costura.color) {
                      item.status = ["Costura"];
                    }
                  });
                  firebase
                    .firestore()
                    .collection("ing")
                    .doc(doc.id)
                    .set({ otros }, { merge: true });
                });
              });
          } catch (error) {
            console.log(error);
          }

          try {
            firebase
              .firestore()
              .collection("corte")
              .where("op", "==", op)
              .where("color", "==", color)
              .get()
              .then((qs) => {
                qs.forEach((doc) => {
                  firebase
                    .firestore()
                    .collection("corte")
                    .doc(doc.id)
                    .update({
                      isEditable: false,
                    });
                });
              });
          } catch (e) {
            console.error(e.message);
          }

          try {
            this.ref
              .doc(value)
              .update(costura)
              .then((_) => {
                message.destroy();
                const args = {
                  message: "Registro agregado existosamente.",
                  top: 80,
                };
                notification.success(args);
                this.setState({
                  fechaIngreso: new Date(),
                  cantIngresada: "",
                });
                this.props.history.push("/Costura/Procesos");
              });
          } catch (error) {
            console.error("Error adding document: ", error);
          }
        });
      this.setState({
        isActive: true,
      });
    } else {
      this.setState({
        isActive: false,
      });
      const msg = {
        message: `La cantidad: ${cantIngresada}, no debe ser mayor a la cantidad principal: ${cantidadCorte}`,
        top: 80,
      };
      notification.error(msg);
    }
  };

  render() {
    const { cantIngresada } = this.state;
    return (
      <div className="content">
        <Row>
          <Col md={12} xs={12}>
            <Card className="card-user">
              <CardHeader>
                <CardTitle className="text-center">NUEVO REGISTRO</CardTitle>
              </CardHeader>
              <CardBody className="ml-3">
                <form>
                  <FormGroup>
                    <Label className="font-weight-bold mt-3">
                      ORDEN DE PRODUCCION
                    </Label>
                    <Input
                      className="col-md-3 d-block"
                      value={this.state.op}
                      disabled
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label className="font-weight-bold">COLOR</Label>
                    <Input
                      className="col-md-3 d-block"
                      value={this.state.color}
                      disabled
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label className="font-weight-bold">
                      CANTIDAD INGRESADA
                    </Label>
                    <Input
                      name="cantIngresada"
                      className="col-md-3 d-block"
                      value={cantIngresada}
                      onChange={this.onChange}
                      autoComplete="off"
                      required
                    />
                  </FormGroup>
                  <Row>
                    <div className="update ml-auto mr-auto mt-3">
                      <Button
                        type="primary"
                        onClick={this.onSubmit}
                        disabled={
                          this.state.isActive || !cantIngresada ? true : false
                        }
                      >
                        Registrar
                      </Button>
                    </div>
                  </Row>
                </form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

export default DirectNewCosturaRecord;
